import React, { useEffect } from 'react';

/**
 * Login Handler
 *
 * Redirects user to Microsoft Entra ID login
 * Client ID and Tenant ID are injected at build time from GitHub Secrets
 */
function Login() {
  useEffect(() => {
    // Check if already authenticated
    const idToken = sessionStorage.getItem('id_token');
    if (idToken) {
      // Already logged in, redirect to app
      window.location.href = '/manheimsupport/index';
      return;
    }

    // OAuth config from environment variables (injected from GitHub Secrets at build time)
    const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID;
    const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID;

    if (!clientId || !tenantId) {
      return;
    }

    // Build Entra ID authorization URL
    // Redirect URI must match what's registered in Entra ID
    const redirectUri = encodeURIComponent(`${window.location.origin}/manheimsupport/callback`);
    // Use openid to get ID token (WORKAROUND until API scope configured)
    const scope = encodeURIComponent('openid profile email');

    // If redirected back here after an OAuth error (e.g. AADSTS50178 – wrong account
    // picked in a multi-account browser session), force the account-picker so the
    // user can choose the correct Cox Automotive account and break the login loop.
    const loginParams = new URLSearchParams(window.location.search);
    const forcePrompt = loginParams.get('prompt') === 'select_account';

    const authUrl =
      `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?` +
      `client_id=${clientId}` +
      `&response_type=code` +
      `&redirect_uri=${redirectUri}` +
      `&response_mode=query` +
      `&scope=${scope}` +
      `&state=${Date.now()}${forcePrompt ? '&prompt=select_account' : ''}`;

    window.location.href = authUrl;
  }, []);

  return (
    <div className="auth-container">
      <div className="auth-spinner" />
    </div>
  );
}

export default Login;
